import { render, staticRenderFns } from "./ExternalTestsList.vue?vue&type=template&id=00e53ab0&scoped=true"
import script from "./ExternalTestsList.vue?vue&type=script&lang=js"
export * from "./ExternalTestsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00e53ab0",
  null
  
)

export default component.exports